import { useState } from 'react';
import { axiosInstance } from '../App';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { FileUp, Loader2, Download, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

export const RebrandPdfDialog = ({ open, onClose }) => {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const reset = () => { setFile(null); setResult(null); setBusy(false); };

  const convert = async () => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await axiosInstance.post('/tools/rebrand-pdf', fd, { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'blob' });
      const name = file.name.replace(/\.pdf$/i, '') + '_Cardoso_Bouw.pdf';
      setResult({ url: URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' })), name });
      toast.success('PDF omgezet naar Cardoso Bouw');
    } catch (e) {
      let msg = 'Omzetten mislukt';
      try { msg = JSON.parse(await e.response?.data?.text())?.detail || msg; } catch (_) { /* ignore */ }
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { reset(); onClose(); } }}>
      <DialogContent className="bg-white max-w-lg" aria-describedby={undefined} data-testid="rebrand-pdf-dialog">
        <DialogHeader><DialogTitle>Leveranciers-PDF op naam van Cardoso Bouw</DialogTitle></DialogHeader>
        <p className="text-sm text-gray-600">Upload een PDF van een leverancier (bijv. Toelevering Online). Logo, kop- en voettekst van de leverancier worden verwijderd en vervangen door jouw logo en bedrijfsgegevens. De inhoud (tekeningen, maten, specificaties) blijft intact.</p>
        <label className="flex flex-col items-center justify-center gap-2 border-2 border-dashed border-[#3da5a5]/50 rounded-xl p-6 cursor-pointer hover:bg-[#3da5a5]/5">
          <FileUp className="w-7 h-7 text-[#3da5a5]" />
          <span className="text-sm text-gray-700">{file ? file.name : 'Kies een PDF-bestand'}</span>
          <input type="file" accept="application/pdf,.pdf" className="hidden" onChange={e => { setFile(e.target.files?.[0] || null); setResult(null); }} data-testid="rebrand-pdf-input" />
        </label>
        {result ? (
          <div className="flex items-center justify-between bg-green-50 border border-green-200 rounded-lg p-3" data-testid="rebrand-pdf-result">
            <span className="flex items-center gap-2 text-sm text-green-800"><CheckCircle2 className="w-4 h-4" />{result.name}</span>
            <a href={result.url} download={result.name} className="inline-flex items-center gap-1 text-sm font-semibold text-white bg-[#3da5a5] hover:bg-[#2d8585] px-3 py-1.5 rounded-md" data-testid="rebrand-pdf-download">
              <Download className="w-4 h-4" />Downloaden
            </a>
          </div>
        ) : (
          <Button onClick={convert} disabled={!file || busy} className="bg-[#3da5a5] hover:bg-[#2d8585] text-white w-full" data-testid="rebrand-pdf-convert">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <FileUp className="w-4 h-4 mr-2" />}Omzetten naar Cardoso Bouw
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};
